import React from "react";
import { connect } from "react-redux";
import { login, toggleAuthStatus } from "../external/actions";
import { getCookie, setCookies } from "../util";
import { Button, Heading, Pane, Paragraph, Small, toaster } from "evergreen-ui";
import { TextField } from "@material-ui/core";
import ReCAPTCHA from "react-google-recaptcha";
import { resolveOnChange } from "antd/lib/input/Input";

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      captcha: "",
      invalidUsername: false,
      invalidUsernameMessage: "",
      invalidPassword: false,
      invalidPasswordMessage: "",
      playoLogo:
        "https://playo-website.gumlet.io/logo/Partner app logo@2x.png?auto=compress,format&q=90",
      onesignalId: "",
      app: true,
    };
  }

  componentDidMount() {
    // window.OneSignal = window.OneSignal || []
    // const OneSignal = window.OneSignal

    // let force = {
    //   force: onesignalId.length > 0 || onesignal.length > 0 ? false : true
    // }

    // OneSignal.push(function () {
    //   OneSignal.showSlidedownPrompt(force)
    // })
    if (!window.location.hash) {
      window.location = window.location + "#loaded";
      window.location.reload();
    }
    if (getCookie("authToken")) {
      this.props.history.push("/");
    }

    // OneSignal.sendTag('new_app_version', 'new_app_version', tagsSent => {
    //   // Callback called when tag has finished sending
    //   console.log('PWA TAG SENT', tagsSent)
    // })
    //   )
    // })
  }

  getOneSignalId = async () => {
    let onesignalId = await localStorage.getItem("onesignalId");
    return onesignalId;
    // window.OneSignal = window.OneSignal || []
    // const OneSignal = window.OneSignal
    // return new Promise((resolve, reject) => {
    //   OneSignal.push(function () {
    //     OneSignal.getUserId().then(function (userId) {
    //       localStorage.setItem('onesignalId', userId)
    //       resolve(userId)
    //       // (Output) OneSignal User ID: 270a35cd-4dda-4b3f-b04e-41d7463a2316
    //     })
    //   })
    // })

    // OneSignal.push(async () => {
    //   /* These examples are all valid */
    //   OneSignal.getUserId(async userId => {
    //     await this.setState({
    //       onesignalId:"89898-89898-89898-8989"
    //     })

    //     localStorage.setItem('onesignalId', userId)

    //     console.log('OneSignal User ID:', userId)

    //     // (Output) OneSignal User ID: 270a35cd-4dda-4b3f-b04e-41d7463a2316
    //   })
    // })
  };

  handleCaptchaChange = (captcha) => {
    this.setState({ captcha });
  };

  inputChange = async (e, type) => {
    e.persist();
    if (type === "username") {
      await this.setState({
        invalidUsername: false,
        username: e.target.value,
      });
    } else {
      await this.setState({
        invalidPassword: false,
        password: e.target.value,
      });
    }
  };

  getInTouch = () => {
    const url = "https://playo.co/contact";
    window.open(url, "_blank");
  };

  downloadApp = () => {
    let standalone = window.navigator.standalone,
      userAgent = window.navigator.userAgent.toLowerCase(),
      safari = /safari/.test(userAgent),
      ios = /iphone|ipod|ipad/.test(userAgent);

    if (ios) {
      if (!standalone && safari) {
        window.location.href =
          "https://itunes.apple.com/us/app/playo-local-sports-community/id1018786950?ls=1&mt=8";
      } else if (!standalone && !safari) {
        window.location.href =
          "https://itunes.apple.com/us/app/playo-local-sports-community/id1018786950?ls=1&mt=8";
      }
    } else {
      if (userAgent.includes("wv")) {
        window.location.href = "https://play.google.com/store/apps/details?id=com.techmash.playo";
      } else {
        window.location.href = "https://play.google.com/store/apps/details?id=com.techmash.playo";
      }
    }
  };

  login = async (e) => {
    e.preventDefault();

    // let userAgent = window.navigator.userAgent.toLowerCase(),
    //   ios = /iphone|ipod|ipad/.test(userAgent)
    // console.log({ ios })
    // let onesignalId = ios ? '' : await this.getOneSignalId()
    let onesignalId = await this.getOneSignalId();
    // window.OneSignal = window.OneSignal || []
    // const OneSignal = window.OneSignal
    console.log({ onesignalId });
    const { username, password, captcha, app } = this.state;
    // console.log({ onesignalId })
    // console.log(this.state)

    if (username && password) {
      await this.props.dispatch(
        login({
          username,
          password,
          onesignalId,
          app,
          captcha,
        })
      );
      if (this.props.loginData) {
        if (this.props.loginData["requestStatus"]) {
          this.props.dispatch(toggleAuthStatus());
          setCookies(this.props.loginData["userAuth"]);
          this.props.history.push("/");
          if (this.props.loginData["requestStatus"] === 0) {
            toaster.warning(this.props.loginData["message"]);
          }
        } else if (this.props.loginData["requestStatus"] === 0) {
          toaster.warning(this.props.loginData["message"]);
        } else {
          if (this.props.loginData["message"] === "invalid username") {
            this.setState({
              invalidUsername: true,
              invalidUsernameMessage: "Incorrect username",
            });
          }
          if (this.props.loginData["message"] === "invalid password") {
            this.setState({
              invalidPassword: true,
              invalidPasswordMessage: "Incorrect password",
            });
          }
        }
      }
    } else {
      if (username === "") {
        await this.setState({
          invalidUsername: true,
          invalidUsernameMessage: "Enter username",
        });
      }
      if (password === "") {
        await this.setState({
          invalidPassword: true,
          invalidPasswordMessage: "Enter password",
        });
      }
      // if (!onesignalId) {
      //   OneSignal.push(function () {
      //     OneSignal.isPushNotificationsEnabled().then(function (isEnabled) {
      //       if (isEnabled) {
      //         toaster.warning('Notification subcription is required')
      //         let force = {
      //           force: true
      //         }
      //         OneSignal.push(function () {
      //           OneSignal.showSlidedownPrompt(force)
      //         })
      //       } else {
      //         Notification.requestPermission().then(function (result) {
      //           console.log(result)
      //           if (result === 'granted') {
      //             window.location.reload()
      //           } else {
      //             toaster.warning(
      //               'Please enable notification from setting and restart the app'
      //             )
      //           }
      //         })
      //       }
      //     })
      //   })
      // }
    }
  };

  render() {
    const {
      playoLogo,
      username,
      password,
      invalidUsername,
      invalidUsernameMessage,
      invalidPassword,
      invalidPasswordMessage,
    } = this.state;

    return (
      <React.Fragment>
        <div className={"login-container"}>
          <Pane
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            height={54}
            marginBottom={10}
          >
            <img className={"playo-logo"} src={playoLogo} alt='playo-logo' />
          </Pane>
          <Pane
            display={"flex"}
            justifyContent={"flex-start"}
            width={"100%"}
            marginTop={10}
            marginBottom={5}
          >
            <Heading size={800}>Login</Heading>
          </Pane>
          <div className={"login-text-field"}>
            <TextField
              error={invalidUsername}
              helperText={invalidUsername ? invalidUsernameMessage : null}
              variant='outlined'
              fullWidth={true}
              label={invalidUsername ? "" : "Username"}
              value={username}
              onChange={(e) => this.inputChange(e, "username")}
              onFocus={() => {
                this.setState({
                  invalidUsername: false,
                  invalidUsernameMessage: "",
                });
              }}
            />
          </div>
          <div className={"login-text-field"}>
            <TextField
              error={invalidPassword}
              helperText={invalidPassword ? invalidPasswordMessage : null}
              variant='outlined'
              fullWidth={true}
              label={invalidPassword ? "" : "Password"}
              type={"password"}
              value={password}
              onChange={(e) => this.inputChange(e, "password")}
              onFocus={() => {
                this.setState({
                  invalidPassword: false,
                  invalidPasswordMessage: "",
                });
              }}
            />
          </div>
          <div className={"login-text-field"}>
            <ReCAPTCHA
              sitekey='6LcftggTAAAAAOo7nJHUSTyNc7Q9bDlZDN5Dvvk7'
              onChange={this.handleCaptchaChange}
            />{" "}
          </div>
          <div className={"login-text-field"}>
            <Button
              appearance='primary'
              justifyContent={"center"}
              height={48}
              width={"100%"}
              onClick={(e) => this.login(e)}
            >
              Login
            </Button>
          </div>

          {/* <div className="download_btn_div">
            <div className="download_img_inner">
              <a href="https://play.google.com/store/apps/details?id=com.techmash.playo">
                <img
                  src="https://playo-website.gumlet.net/download/google-play-new.png?auto=compress,format"
                  alt="Google-play"
                />
              </a>
            </div>
            <div className="download_img_inner">
              <a href="https://itunes.apple.com/us/app/playo-local-sports-community/id1018786950?ls=1&mt=8">
                <img
                  src="https://playo-website.gumlet.net/download/app-store-new.png?auto=compress,format"
                  alt="Apple-store"
                />
              </a>
            </div>
          </div> */}

          <Paragraph marginTop={16}>
            <Small>{"Don't have an account yet? "}</Small>
            <Small color={"#00783e"} onClick={() => this.getInTouch()}>
              {"Get in touch"}
            </Small>
            <Small>{", to become a Playo partner."}</Small>
            <Pane marginTop={20}>
              <Small>{"This is a Playo Partner only app. Looking for "}</Small>
              <Small color={"#00783e"} onClick={() => this.downloadApp()}>
                {"Playo App?"}
              </Small>
            </Pane>
          </Paragraph>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ loginData, oneSignalId }) => ({
  loginData,
  oneSignalId,
});

export default connect(mapStateToProps)(Login);
